























import Component from 'vue-class-component'
import { Mixins, Prop } from 'vue-property-decorator'
import BaseIcon from 'vuecomponents/base_icon.vue'
import { __ } from 'bits/intl'

type AudioDevice = {
  id: string
  label: string
}

@Component({ components: { BaseIcon } })
export default class ScreenshareBoothAudioSelect extends Mixins() {
  @Prop({ required: true }) audioDevices!: [AudioDevice]
  @Prop({ required: true }) activeAudioDeviceId!: string
  @Prop({ required: true }) chooseAudioDevice!: string
}
